export default {
	['NAV_URL'](state, payload) {
		state.navUrl = payload;
	}
};
